export const SIGNUP_SOURCE_KEY = 'dathent.signup.source';

export function rememberChatGptSignupSource(storage = globalThis?.localStorage) {
  try {
    storage?.setItem(SIGNUP_SOURCE_KEY, 'chatgpt');
  } catch {
    // Storage can be unavailable in private browsing; pending OAuth remains authoritative.
  }
}

// TASK (2026-09-10, ChatGPT-skip-onboarding): `user.signupSource` (the
// server's raw signup_source column, wired through client.js's
// getCurrentUser — see A2/A1) is now the authoritative signal, checked
// FIRST. The pendingOAuth/localStorage checks remain as the fallback for
// accounts that predate that field, or a Google sign-up before A2's
// ?next= hand-off is live server-side.
export function isChatGptOrigin(pendingOAuth = null, user = null, storage = globalThis?.localStorage) {
  if (user?.signupSource === 'chatgpt') return true;
  if (pendingOAuth?.pending === true || pendingOAuth?.resumeUrl) return true;
  try {
    return storage?.getItem(SIGNUP_SOURCE_KEY) === 'chatgpt';
  } catch {
    return false;
  }
}
